import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconTraectoryBlueSizeS from './IconTraectoryBlue_size_s';

const props: CreateIconArguments = {
  l: IconTraectoryBlueSizeS,
  m: IconTraectoryBlueSizeS,
  s: IconTraectoryBlueSizeS,
  xs: IconTraectoryBlueSizeS,
  name: 'IconTraectoryBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
